import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';
import { ArmJointPositions } from '@sb/motion-planning';

export const AssemblyItemType = zod.enum(['system', 'user']);
export type AssemblyItemType = zod.infer<typeof AssemblyItemType>;

export const AssemblyDataType = zod.enum(['int', 'real', 'sint', 'dint']);
export type AssemblyDataType = zod.infer<typeof AssemblyDataType>;

export const AssemblyItemFieldType = zod.enum([
  'robotStatus',
  'cartesianPosition',
  'jointPosition',
  'controlBoxIOPorts',
  'flangeIOPorts',
  'timestamp',
  'variable',
  'robotControl',
  'reserved',
]);
export type AssemblyItemFieldType = zod.infer<typeof AssemblyItemFieldType>;

export const AssemblyItem = zod.object({
  id: zod.string(),
  name: zod.string(),
  variableID: zod.string().optional(),
  type: AssemblyItemType,
  fieldType: AssemblyItemFieldType,
  offset: zod.number(),
  length: zod.number(),
  dataType: AssemblyDataType,
  dataTypeLength: zod.number().optional(),
  description: zod.string().optional(),
});

export type AssemblyItem = zod.infer<typeof AssemblyItem>;

export const EtherNetIPConfig = zod.object({
  id: zod.string(),
  host: zod.string(),
  port: zod.number(),
  uponConnectionLoss: zod.enum(['pause', 'stop', 'ignore']),
  inputAssembly: zod.array(AssemblyItem),
  outputAssembly: zod.array(AssemblyItem),
  edsFileRedownloadNeeded: zod.boolean().default(false),
  updateRateMs: zod.number().int().min(10).max(5000).default(1000),
});

export type EtherNetIPConfig = zod.infer<typeof EtherNetIPConfig>;

export const NullableEtherNetIPConfig = EtherNetIPConfig.nullable();

export type NullableEtherNetIPConfig = zod.infer<
  typeof NullableEtherNetIPConfig
>;

export const EtherNetIPFieldValues = zod.object({
  robotStatus: zod.number(),
  cartesianPosition: CartesianPose,
  jointPosition: ArmJointPositions,
  controlBoxIOPorts: zod.record(zod.string(), zod.enum(['high', 'low'])),
  flangeIOPorts: zod.record(zod.string(), zod.enum(['high', 'low'])),
  timestamp: zod.number(),
});

export type EtherNetIPFieldValues = zod.infer<typeof EtherNetIPFieldValues>;
